import { Environment, getEnvironment } from "@equipmentshare/which-env";

import { getEnvUrl } from "../../api";
import { STRING_REPLACE_IDENTIFIER } from "../../transformations";

export const LOCAL_T3 = "http://localhost:8000" as const;

export const TRACKER_INSTALL_GUIDE = {
  FJ2500:
    "https://help.estrack.com/en/articles/8436714-telematics-device-pui-fj2500-installation-guide",
  GL520:
    "https://help.estrack.com/en/articles/5345060-telematics-device-queclink-gl500-installation-guide",
  MC4_PLUS:
    "https://help.estrack.com/en/articles/3056073-telematics-device-mc4-installation",
  MCX101:
    "https://help.estrack.com/en/articles/10707713-telematics-device-morey-mcx1m1-101-installation-guide",
  T3_DASH_CAM:
    "https://drive.google.com/file/d/1xqt4uXnSbpxdCKRQpAbAeIO06IKUOizD/view",
} as const;

export function getExternalUrls() {
  const RESOURCE_MAP = {
    LEARNING_RESOURCES: "https://help.estrack.com/en", // TODO: Add actual url once ready
    DASHBOARD: getEnvUrl("resource-map.estrack.com"),
  } as const;

  return {
    PIM_APP: getEnvUrl("pim.estrack.com"),
    RESOURCE_MAP,
    T3:
      getEnvironment() === Environment.LOCAL
        ? LOCAL_T3
        : getEnvUrl("app.estrack.com"),
    T3_PERMISSIONS_HELP:
      "https://help.estrack.com/en/articles/2920734-t3-fleet-web-app-roles-and-permissions",
    T3_ADDITIONAL_DETAILS_HELP:
      "https://help.estrack.com/en/articles/2920735-updating-asset-details-and-settings",
    T3_DEVICE_INSTALL_STATUS_HELP:
      "https://help.estrack.com/en/articles/9949071-setup-page-device-install-status-help",
    TRACKER_INSTALL_GUIDE,
  } as const;
}

// Deprecated: Use getExternalUrls() instead to avoid SSR issues with window access
// export const EXTERNAL_URLS = getExternalUrls();

export const T3_PATHNAME = {
  ASSET_HISTORY: `/assets/all/asset/${STRING_REPLACE_IDENTIFIER}/history`,
  BULK_IMPORT_ASSETS: "/assets/bulk-add",
  CATEGORIES_AND_CLASSES: "/assets/categories",
  COMPANY_ASSETS: "/assets/assets",
  CREATE_ASSET: "/assets/create",
  CREATE_GEOFENCES: "/geofences/create",
  CREATE_USER_GROUPS: "/company-admin/groups/users",
  EDIT_ASSET: `/assets/all/asset/${STRING_REPLACE_IDENTIFIER}/edit`,
  EDIT_BRANCH: "/company-admin/branches/edit",
  USERS: "/company-admin/users/all",
  // asset-management routes
  ARCHIVED_ASSETS: "/resources/archive",
  BULK_ENRICHMENT: "/resources/enrichment",
  CREATE_ASSET_V2: "/resources/create-v2",
  EDIT_RENT_FORM: `/resources/on-rent-form/${STRING_REPLACE_IDENTIFIER}/edit`,
  ON_RENT_FORM: `/resources/on-rent-form/${STRING_REPLACE_IDENTIFIER}`,
  RESOURCES: "/resources",
  SETUP_QUEUE: "/resources/setup-queue",
} as const;

export const PIM_PATHNAME = {
  CREATE_CATEGORY: "/categories/new",
};
